import actionTypes from '../actionTypes';

export const getAgreements = () => ({
  type: actionTypes.AGREEMENTS_GET_REQUEST,
});

export const getAgreement = (agreementId) => ({
  type: actionTypes.AGREEMENT_GET_REQUEST,
  agreementId,
});

export const selectAgreement = (agreement) => ({
  type: actionTypes.AGREEMENT_SELECT,
  agreement,
});

export const createAgreement = (agreement) => ({
  type: actionTypes.AGREEMENT_CREATE_REQUEST,
  agreement,
});

export const updateAgreement = (agreementId, agreement) => ({
  type: actionTypes.AGREEMENT_UPDATE_REQUEST,
  agreementId,
  agreement,
});

export const deleteAgreement = (agreementId) => ({
  type: actionTypes.AGREEMENT_DELETE_REQUEST,
  agreementId,
});

export const getAgreementContractBlockContents = (agreementId) => ({
  type: actionTypes.AGREEMENT_CONTRACT_BLOCKS_GET_REQUEST,
  agreementId,
});

export const saveAgreementContractBlockContent = (contractBlock) => ({
  type: actionTypes.AGREEMENT_CONTRACT_BLOCK_SAVE_REQUEST,
  contractBlock,
});

export const saveAgreementContractBlocks = (contractBlocks) => ({
  type: actionTypes.AGREEMENT_CONTRACT_BLOCKS_SAVE,
  contractBlocks,
});

export const createAgreementSentence = (agreementSentence) => ({
  type: actionTypes.AGREEMENT_SENTENCE_CREATE_REQUEST,
  agreementSentence,
});

export const updateAgreementSentence = (id, agreementSentence) => ({
  type: actionTypes.AGREEMENT_SENTENCE_UPDATE_REQUEST,
  id,
  agreementSentence,
});



// WEBPACK FOOTER //
// src/redux/actions/agreements.js